import { render, staticRenderFns } from "./AwardsList.vue?vue&type=template&id=2eba0da0&scoped=true"
import script from "./AwardsList.vue?vue&type=script&lang=js"
export * from "./AwardsList.vue?vue&type=script&lang=js"
import style0 from "./AwardsList.vue?vue&type=style&index=0&id=2eba0da0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba0da0",
  null
  
)

export default component.exports